import { render, staticRenderFns } from "./notificationBar.vue?vue&type=template&id=2db0b643&"
import script from "./notificationBar.vue?vue&type=script&lang=js&"
export * from "./notificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports